/**
 * Returns the axis-name store key for a given widget.
 *
 * Single-product charts get a product-scoped key (`${widgetId}_${product}`) so
 * per-product axis renames don't bleed across products.  MPC mode and charts
 * with no active product use the bare widgetId (one set of overrides for all axes).
 *
 * All three save/load sites (Screenshot.tsx, ScreenshotActivity.tsx,
 * ScreenshotSettingsForm.tsx) must call this helper so the keys can never drift.
 */
export function getEffectiveAxisNameId(
  widgetId: string | undefined,
  multiProductActive: boolean | undefined,
  requestProduct: string | undefined
): string {
  if (!widgetId || multiProductActive || !requestProduct) return widgetId ?? "";
  return `${widgetId}_${requestProduct}`;
}
